import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * 사이드바 결재 알림으로 페이지에 들어왔다는 표시.
 * 같은 주소로 다시 이동해도 값이 바뀌도록 클릭 시각을 넣는다.
 */
export const APPROVAL_ALERT_STATE_KEY = 'approvalAlertAt';

export const createApprovalAlertState = () => ({ [APPROVAL_ALERT_STATE_KEY]: Date.now() });

export const useApprovalAlertAt = (): number | undefined => {
  const location = useLocation();
  return (location.state as Record<string, number> | null)?.[APPROVAL_ALERT_STATE_KEY];
};

/**
 * 알림으로 들어온 경우 결재 목록에서 한 번만 onEnter를 실행하고 표시를 지운다.
 * 지우지 않으면 탭을 옮겼다 돌아올 때마다 다시 실행된다.
 */
export const useConsumeApprovalAlert = (enabled: boolean, onEnter: () => void) => {
  const location = useLocation();
  const navigate = useNavigate();
  const approvalAlertAt = useApprovalAlertAt();

  useEffect(() => {
    if (!enabled || !approvalAlertAt) return;
    onEnter();
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [enabled, approvalAlertAt]);
};
